/**
 * 게시판 마스터 (보드 목록·생성·편집·삭제) — $j.F.Admin.BoardMaster (정적 모듈)
 *
 * 마크업은 adm/pages/board/_master.blade.php (#board-master). 전체 페이지(/adm/board → Pages/Admin/BoardMaster)와
 * 글관리 화면의 '게시판관리' JBModal(/adm/board?bare=1 → BoardPosts 의 onOpen) 양쪽이 init() 을 부른다.
 */
export default class BoardMaster {
    static init() {
        // 모달은 열 때마다 다시 불린다 — 네임스페이스로 한 번만 묶는다
        $('#board-master').off('.bm')
            .on('click.bm', '[data-act="new"]', () => BoardMaster.openForm(null))
            .on('click.bm', '[data-act="edit"]', function () { BoardMaster.openForm($(this).data('board')); })
            .on('click.bm', '[data-act="delete"]', function () { BoardMaster.remove($(this).data('num'), $(this).attr('data-name')); });
        // 폼은 JBModal 안(#board-master 밖)에 그려진다
        $(document).off('.bm')
            .on('click.bm', '#boardForm [data-act="cancel"]', () => $j.Ui.JBModal.close('boardModal'))
            .on('click.bm', '#boardForm [data-act="save"]', () => BoardMaster.save());
    }

    // 신규(board=null)·편집 모달
    static openForm(board) {
        const title = board ? `보드 편집 — ${board.board_name}` : '신규 보드';
        $j.Ui.JBModal.html('boardModal', BoardMaster.formHtml(board), title, {width: '560px'});
    }

    // 삭제 — 글이 한 건이라도 있으면 서버에서 거부 (BoardWriteService::delete)
    static remove(num, name) {
        if (!confirm(`"${name}" 보드를 삭제할까요?\n(글이 있으면 거부됩니다.)`)) return;
        $.post('/adm/ajax/board/delete', {num: num}, function (res) {
            if (res && res.result) {
                location.reload();
            } else {
                alert((res && res.message) || '삭제에 실패했습니다.');
            }
        });
    }

    // 폼 HTML — 신규일 때 board=null
    static formHtml(board) {
        const isEdit = !!board;
        const categories = isEdit ? (board.categories || []).join(',') : '공지,업데이트';
        const escVal = s => String(s == null ? '' : s).replace(/"/g, '&quot;');
        return `
        <form id="boardForm">
            <input type="hidden" name="num" value="${isEdit ? board.num : ''}">
            <div class="form-group">
                <label>board_code <small class="text-muted">(URL slug · 영문 소문자/숫자/언더스코어)</small></label>
                <input type="text" name="board_code" class="form-control" maxlength="20" placeholder="jb_notice"
                       value="${isEdit ? escVal(board.board_code) : ''}" ${isEdit ? 'readonly' : ''}>
            </div>
            <div class="form-group">
                <label>게시판명</label>
                <input type="text" name="board_name" class="form-control" maxlength="50" placeholder="장비불러 공지사항"
                       value="${isEdit ? escVal(board.board_name) : ''}">
            </div>
            <div class="form-group">
                <label>사이트 (분류1)</label>
                <select name="site_code" class="form-control">
                    <option value="jb"    ${!isEdit || board.site_code === 'jb'    ? 'selected' : ''}>장비불러 (jb)</option>
                    <option value="devil" ${ isEdit && board.site_code === 'devil' ? 'selected' : ''}>악덕알리미 (devil)</option>
                </select>
            </div>
            <div class="form-group">
                <label>분류2 목록 <small class="text-muted">(콤마 구분. 예: 공지,업데이트,이벤트)</small></label>
                <textarea name="categories" class="form-control" rows="2" placeholder="공지,업데이트">${escVal(categories)}</textarea>
            </div>
            <div class="form-group">
                <label>
                    <input type="checkbox" name="is_active" value="1"
                           ${!isEdit || parseInt(board.is_active, 10) === 1 ? 'checked' : ''}> 활성
                </label>
            </div>
            <div class="bm-foot">
                <button type="button" class="btn btn-secondary btn-sm" data-act="cancel">취소</button>
                <button type="button" class="btn btn-primary btn-sm" data-act="save">저장</button>
            </div>
        </form>`;
    }

    static save() {
        const $f = $('#boardForm');
        const payload = {
            num:         $f.find('[name=num]').val(),
            board_code:  $f.find('[name=board_code]').val().trim(),
            board_name:  $f.find('[name=board_name]').val().trim(),
            site_code:   $f.find('[name=site_code]').val(),
            categories:  $f.find('[name=categories]').val(),
            is_active:   $f.find('[name=is_active]').is(':checked') ? 1 : 0,
        };
        $.post('/adm/ajax/board/save', payload, function (res) {
            if (res && res.result) {
                $j.Ui.JBModal.close('boardModal');
                location.reload();
            } else {
                alert((res && res.message) || '저장에 실패했습니다.');
            }
        });
    }
}
